@if (showMessage) {
  <span class="no-app-found">No apps found.</span>
}
